/* Preserve the native cart's focus trap; restore the initiating control on close. */
(() => {
  let opener = null;
  document.addEventListener('click', (event) => {
    const target = event.target.closest?.('[data-cart-toggle], [data-add-to-cart]');
    if (target) opener = target;
  }, true);
  function bind() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.dataset.nsFocusBound) return;
    drawer.dataset.nsFocusBound = 'true';
    let wasOpen = drawer.classList.contains('is-open');
    new MutationObserver(() => {
      const isOpen = drawer.classList.contains('is-open');
      if (wasOpen && !isOpen) {
        setTimeout(() => {
          if (drawer.classList.contains('is-open')) return;
          if (document.activeElement !== document.body && !drawer.contains(document.activeElement)) return;
          const fallback = [...document.querySelectorAll('[data-cart-toggle]')].find(el => el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
          const next = opener?.isConnected && opener.getClientRects().length ? opener : fallback;
          next?.focus({preventScroll: true});
        }, 450);
      }
      wasOpen = isOpen;
    }).observe(drawer, {attributes: true, attributeFilter: ['class']});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
  document.addEventListener('shopify:section:load', bind);
})();
